import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initLiveContent } from './lib/liveContent'
import { initSiteIntegrations } from './lib/siteIntegrations'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

initLiveContent()
initSiteIntegrations()
